import React from 'react'

const ConsultarMaestroConcentracion = ({setmodalOnConsultarMaestroConcentracion,dataUnMaestroConcentracion}) => {
    const handleCancelarClick=()=>{
        setmodalOnConsultarMaestroConcentracion(false)
    }
  return (
    <div
    className="z-40 fixed top-0 left-0 w-full h-full outline-none overflow-x-hidden overflow-y-auto bg-[#f4f6fa]"
    id="exampleModalScrollable"
    tabIndex="-1"
    aria-labelledby="exampleModalScrollableLabel"
    aria-hidden="true"
  >
    <div className="sm:h-[calc(100%-3rem)] max-w-5xl  mx-auto relative w-auto pointer-events-none ">
      <div className="max-h-full overflow-hidden border-none shadow-lg relative flex flex-col w-full pointer-events-auto bg-white bg-clip-padding rounded-md outline-none text-current">
        <div className="flex flex-shrink-0 items-center justify-between p-2 border-b border-gray-200 rounded-t-md bg-[#05a29d]">        
    <h5
      className="text-xl font-medium leading-normal text-white"
      id="exampleModalScrollableLabel"
    >
     Consultar Maestro Concentración
    </h5>  
          <button
            type="button"
            onClick={handleCancelarClick}
            className="btn-close box-content w-4 h-4 p-1 text-black border-none rounded-none opacity-50 focus:shadow-none focus:outline-none focus:opacity-100 hover:text-black hover:opacity-75 hover:no-underline"
            data-bs-dismiss="modal"
            aria-label="Close"
          >
            X
          </button>
        </div>
        <div className="flex-auto overflow-y-auto relative">
              <div className="flex">                
                <div className="w-full  px-1 ">
                  <label className="form-label inline-block mb-2 text-gray-900 font-medium ">
                    Código 
                  </label>
                  <input
                  defaultValue={dataUnMaestroConcentracion.CncCd}
                    disabled={true}                
                    name='codigo'
                    autoComplete="off"
                    type="text"
                    className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-[#eaebec] bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                    id="exampleFormControlInput1"
                    placeholder=""
                    readOnly
                  />
                  
                </div>
                
                
              </div>
              <div className="flex my-2">
              
                <div className="w-full  px-1 ">
                  <label className="form-label inline-block mb-2 text-gray-900 font-medium ">
                    Descripción 
                  </label>
                  <input
                    
                    defaultValue={dataUnMaestroConcentracion.CncDes}
                    disabled={true}
                    name='palabraClave'             
                    autoComplete="off"
                    type="text" 
                    className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-[#eaebec] bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                    id="exampleFormControlInput1"
                    placeholder=""
                  />
                  
                </div>
              </div> 
              
        </div>
        <div className="flex flex-shrink-0 flex-wrap items-center justify-end p-2 border-t border-gray-200 rounded-b-md">
          <button
            type="button"
            onClick={handleCancelarClick}
            className="inline-block px-4 py-1.5 bg-purple-600 text-white font-medium text-xs leading-tight  rounded shadow-md hover:bg-purple-700 hover:shadow-lg focus:bg-purple-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-purple-800 active:shadow-lg transition duration-150 ease-in-out"
            data-bs-dismiss="modal"
          >
            Cerrar
          </button>
          
        </div>
        
        
      </div>
    </div>    
   
    
  </div>
  )
}

export default ConsultarMaestroConcentracion